const getPageCount = (arrayLength: number, perPage: number) =>
  Math.ceil(arrayLength / perPage);

const getItemsToRender = <T>(
  array: Array<T>,
  currentPage: number,
  perPage: number
) => {
  const currentPageIndex = currentPage - 1;
  const firstIndex = currentPageIndex * perPage;
  const endIndex = firstIndex + perPage;
  return endIndex >= array?.length
    ? array?.slice(firstIndex, array.length)
    : array?.slice(firstIndex, endIndex);
};

export { getPageCount, getItemsToRender };
